class GnlMailOntanimlarDTO {
    id: number = null;
    organizasyonId?: number = null;
    mailTipId?: number = null;
    konu?: string = "";
    icerik?: string = "";
    bilgi?: string = "";
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
}
export default GnlMailOntanimlarDTO;